import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/reports/product-detail");

export const Route = createFileRoute("/reports/product-detail")({
  head: () => ({
    meta: [
      { title: "Product detail report — LevelLoad" },
      { name: "description", content: "Product detail report — LevelLoad transport planning." },
      { property: "og:title", content: "Product detail report — LevelLoad" },
      {
        property: "og:description",
        content: "Product detail report — LevelLoad transport planning.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
